import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Box } from "@material-ui/core";
import { GetPropertyMarketingByPropertyId } from "../../../../../../Services";
import { GetPropertyPublishedImages } from "../../../../../../Services/SmartProposal";
import {
  BasicTable,
  TableSkeleton,
  DeleteConfirmationDialog,
  TableEditDeleteActions,
  CustomPagination,
  CustomButton,
  CustomCard,
  CustomSwitch,
  MarketingGallerySkeleton,
} from "../../../../../../Components";
import {
  FilterIcon,
  UnitSizeIcon,
  TagIcon,
  BedIcon,
  FlamefireIcon,
  RocketIcon,
  GoldIcon,
} from "../../../../../../assets/icons";
import { useTranslate } from "../../../../../../Hooks";
import { useVerticalNav } from "../../../../../../Contexts/VerticalNavContext";
import MarketingGallery from "./UI/MarketingGallery/MarketingGallery";

//  styles
import useStyles from "./styles";

function Marketing({ propretyId, testImages }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const { setAlertBoxContent } = useVerticalNav();

  const [isLoading, setIsLoading] = useState(false);
  const [propertyMarketingData, setPropertyMarketingData] = useState([]);
  const [propertyPublishedImages, setPropertyPublishedImages] = useState([]);

  const getPropertyMarketingData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await GetPropertyMarketingByPropertyId(propretyId);
      if (res !== null && res !== undefined) {
        setPropertyMarketingData(res);
      }
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("something-went-wrong"),
        onClose: () => setAlertBoxContent(null),
      });
    } finally {
      setIsLoading(false);
    }
  }, [propretyId]);

  const getPropertyPublishedImages = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await GetPropertyPublishedImages(propretyId);
      if (res !== null && res !== undefined) {
        setPropertyPublishedImages(res);
      }
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("something-went-wrong"),
        onClose: () => setAlertBoxContent(null),
      });
    } finally {
      setIsLoading(false);
    }
  }, [propretyId]);

  useEffect(() => {
    getPropertyMarketingData();
    getPropertyPublishedImages();
  }, [getPropertyMarketingData, getPropertyPublishedImages]);

  return (
    <Box className={styles.container}>
      <Box className={styles.leftSectionContainer}>
        {isLoading ? (
          <MarketingGallerySkeleton />
        ) : (
          <MarketingGallery
            propretyId={propretyId}
            PropertyImages={propertyPublishedImages}
          />
        )}
      </Box>
      <Box className={styles.rightSectionContainer}>
      </Box>
    </Box>
  );
}

export default Marketing;
